import { FormType } from "../types/forms";
import API from "./API";

export const apiSubmitForm = (
  formType: FormType,
  data: Record<string, any>
) => {
  return API.post("/formSubmission/submitForm", { formType, formData: data });
};
